export default __webpack_public_path__ + "down-arrow.c1f0c9005446071e6487737e9bb42dc4.svg";